import React, { useState, useEffect } from 'react';

export default function MaintenancePage({ apiUrl }) {
  const [maintenance, setMaintenance] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/api/maintenance`)
      .then(r => r.json())
      .then(d => { setMaintenance(d); setLoading(false); })
      .catch(e => { console.error(e); setLoading(false); });
  }, [apiUrl]);

  if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;

  return <div style={{ padding: '20px' }}><h1>Maintenance</h1><p>Total Records: {maintenance.length}</p></div>;
}